import { useEffect } from "react"

import AccountTab from "./AccountTab"
import GeneralTab from "./GeneralTab"
import MailboxTab from "./mailbox/MailboxTab"
import ParentTabNav from "./ParentTabNav"
import PageContentWrapper from "../../../components/pageContentWrapper/PageContentWrapper"
import { useUserQuery } from "../../../networking/queries"
import { ParentTabNavOption } from "../../../types"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"
import useParentTabNavStore from "../hooks/useParentTabNavStore"

const ParentPage = () => {
  const { selectedTab, setSelectedTab } = useParentTabNavStore()
  const { user } = useUserQuery()
  const { selectedUserId } = useFamilyUserSelectStore()
  const isCurrentUser = selectedUserId === user?.id

  // Coparent should only see home tab
  useEffect(() => {
    if (!isCurrentUser) {
      setSelectedTab(ParentTabNavOption.HOME)
    }
  }, [isCurrentUser, setSelectedTab])

  return (
    <div className="w-full mx-auto max-w-[600px] pb-[15vh]">
      {isCurrentUser && <ParentTabNav />}
      <PageContentWrapper mobileGutter={true}>
        {selectedTab === ParentTabNavOption.HOME && <GeneralTab />}
        {isCurrentUser && selectedTab === ParentTabNavOption.MAILBOX && (
          <MailboxTab />
        )}
        {isCurrentUser && selectedTab === ParentTabNavOption.ACCOUNT && (
          <AccountTab />
        )}
      </PageContentWrapper>
    </div>
  )
}

export default ParentPage
